export default __webpack_public_path__ + "static/meshmate-kelechi-precious-b4266dcc6f3efc086de0ef7440b1b861.webp";